<div class="events-area bg-f9f9f9 pt-70" style="margin-top: -50px;">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="coaching-events-content dividerHeading">
                    <!--<span class="sub-title">COACHING PROGRAM</span>-->
                    <h4 class="inter-font d-none d-lg-block" style="text-align: center;"><span>Recent News</span></h4>
                    <h5 class="inter-font d-lg-none" style="text-align: center;">Recent News</h5>
                    <div class="single-coaching-events-box"
                         style="height: 482px; background-color: #f9be2b; text-align: center;">
                        <!--<span class="location"><i class='bx bx-map'></i> New York</span>-->

                        <marquee width="100%" behavior="scroll" direction="up" str height="100%"
                                 onMouseOver="this.stop();"
                                 onMouseOut="this.start();">

                            <ol class="inner">
                                <!-- <li><a href="#">
                                     महत्वपूर्ण सूचना
                                     <br>
                                     Make the online payment only on the account number given below. <br>
                                     ऑनलाइन भुगतान केवल नीचे दिए गए अकाउंट नंबर पर ही करें।<br><br>

                                     <table style="border: 2px solid;">
                                         <tr style="border: 2px solid;">
                                             <td style="border: 2px solid; font-weight: bold;">Account Holder Name:</td>
                                             <td style="border: 2px solid; font-weight: bold;">Swami Vivekanand Subharti
                                                 University Distance Education</td>
                                         </tr>
                                         <tr style="border: 2px solid;">
                                             <td style="border: 2px solid; font-weight: bold;">Account Number:</td>
                                             <td style="border: 2px solid; font-weight: bold;">628501043170</td>
                                         </tr>
                                         <tr style="border: 2px solid;">
                                             <td style="border: 2px solid; font-weight: bold;">IFSC Code:</td>
                                             <td style="border: 2px solid; font-weight: bold;">ICIC0006285</td>
                                         </tr>
                                         <tr style="border: 2px solid;">
                                             <td style="border: 2px solid; font-weight: bold;">Branch:</td>
                                             <td style="border: 2px solid; font-weight: bold;">65 Shiv Puri Hapur Road Meerut</td>
                                         </tr>
                                     </table><br>
                                     Don't give cash to anyone. <br>
                                     किसी भी व्यक्ति को नकद पैसे न दें।
                                 </a>
                                     <hr>
                                 </li>-->
                                <li><a href="#">All students and visitors are hereby informed that Mr. Rajat Sarkar has
                                    already left the Distance Education department from Swami Vivekanand Subharti
                                    University, Meerut and it is requested to you all that please do not transfer or
                                    give any money to him or in his bank account. If anyone will do this then University
                                    will not be responsible for any monetary loss, the sender is own responsible for
                                    their act.</a>
                                    <hr>
                                </li>

                                <li><a href="black-list-institute.php">Black Listed Institutes </a>
                                    <hr>
                                </li>


                                <li><a href="dde_files/Time Table Update.pdf" target="_blank">Time Table CALENDER
                                    BATCH-2021</a>
                                    <hr>
                                </li>
                                <li><a href="images/Fraud-Institute-11-8-21.xlsx" target="_blank">Fraud Institute
                                    List</a>
                                    <hr>
                                </li>

                                <li><a href="https://www.subhartidde.com/no-study-center/index.php">No Study Center</a>

                                    <hr>
                                </li>
                                <li><a href="documents/PROSPECTS_FAKE.pdf" target="_blank">It has come to the notice of
                                    the Directorate of Distance Education, SVSU, that
                                    a FAKE PROSPECTUS is circulating on social media/WhatsApp. group and other
                                    digital media platform. This PROSPECTUS has not been issued by Directorate of
                                    Distance Education, SVSU, Meerut. <br>
                                    Candidate and Students are advised to be more cautious about such FAKE
                                    PROSPECTUS. The genuine prospectus is only available at our official website
                                    www.subhartidde.com and www.subhartidde.co.in, or from the CAMPUS.<br>
                                    Kindly be cautious while taking admission and transferring money in name of
                                    admission to the University.
                                    <br>
                                    <span style="color:red">click here to see FAKE PROSPECTUS</span>
                                </a>
                                    <hr>
                                </li>

                                <li><a href="documents/Notification.jpg" target="_blank">
                                    3rd February 2021 <br>
                                    Public Notice.
                                </a>
                                    <hr>
                                </li>

                                <!-- <li><a href="documents/NewFeeStr_2020_21.pdf" target="_blank">
                                    14 October 2020 <br>
                                    New fee Structure for Academic session 2020-21 and Calendar 2021.
                                </a>
                                    <hr>
                                </li> -->
                                <li><a href="documents/1471046_Public-Notice-DEB.pdf" style="width:320px" target="_top">
                                    Continuation of recognition for a period of one year for Academic session 2020-21
                                    and Calendar 2021.
                                </a>
                                    <hr>
                                </li>
                            </ol>
                        </marquee>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="coaching-events-image">
                    <img src="assets/img/business-coach/business-coach9.jpg" alt="image">
                </div>
            </div>
        </div>
    </div>
    <!--<div class="c-shape5"><img src="assets/img/business-coach/c-shape5.png" alt="image"></div>-->
</div>
